import { render, staticRenderFns } from "./DiscountsListItem.vue?vue&type=template&id=03f3ea1b&"
import script from "./DiscountsListItem.vue?vue&type=script&lang=js&"
export * from "./DiscountsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports